import { SvgIcon, SvgIconProps } from "@mui/material";

const Shirt = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 640 512" sx={{ "& .secondary": { opacity: 0.4 } }} {...props}>
      <path
        d="M209.6 16h32C249.1 52.47 281.4 80 320 80s70.95-27.53 78.38-64h32C422.5 70.13 376.3 112 320 112S217.5 70.13 209.6 16z"
        fill="currentColor"
      />
      <path
        className="secondary"
        d="M640 162.8c0 6.917-2.293 13.88-7.012 19.7l-49.96 61.63c-6.32 7.796-15.62 11.85-25.01 11.85c-7.01 0-14.07-2.262-19.97-6.919L480 203.3V464c0 26.51-21.49 48-48 48H208C181.5 512 160 490.5 160 464V203.3L101.1 249.1C96.05 253.7 88.99 255.1 81.98 255.1c-9.388 0-18.69-4.057-25.01-11.85L7.012 182.5C2.292 176.7-.0003 169.7-.0003 162.8c0-9.262 4.111-18.44 12.01-24.68l135-106.6C159.8 21.49 175.7 16 191.1 16h17.62C217.5 70.13 263.7 112 320 112s102.5-41.87 110.4-96h17.6c16.35 0 32.22 5.49 44.99 15.57l135 106.6C635.9 144.4 640 153.6 640 162.8z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default Shirt;
